<template>
    <div class="flex flex-col space-y-6">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'FeConfiguratorRadios',
};
</script>
